var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("SidebarWidget", {
    attrs: {
      title: _vm.$gettext("Konversationen"),
    },
    on: {
      scroll: _vm.handleScroll,
    },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function fn() {
          return [
            _c(
              "div",
              {
                ref: "scrollableArea",
                staticClass: "scrollable_area blubber_thread_widget",
                class: {
                  scrolled: _vm.scrolled,
                },
              },
              [
                _c(
                  "transition-group",
                  {
                    attrs: {
                      name: "blubberthreadwidget-list",
                      tag: "ol",
                    },
                  },
                  [
                    _vm._l(_vm.sortedThreads, function (thread) {
                      return _c(
                        "li",
                        {
                          key: thread.id,
                          class: _vm.threadClasses(thread),
                          attrs: {
                            "data-thread_id": thread.id,
                            "data-unseen_comments": thread.unseenComments,
                          },
                          on: {
                            click: function click($event) {
                              $event.preventDefault()
                              return _vm.changeActiveThread(thread.id)
                            },
                          },
                        },
                        [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: _vm.link(thread.id),
                              },
                            },
                            [
                              _c("div", {
                                staticClass: "avatar",
                                style: {
                                  backgroundImage: "url(" + thread.avatar + ")",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "info",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "name",
                                    },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(thread.name) +
                                          "\n                            "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("studip-date-time", {
                                    attrs: {
                                      timestamp:
                                        _vm.threadLatestActivity(thread),
                                      relative: true,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _vm.hasMoreThreads
                      ? _c(
                          "li",
                          {
                            key: "more",
                            ref: "more",
                            staticClass: "more",
                          },
                          [
                            _c("studip-asset-img", {
                              attrs: {
                                file: "loading-indicator.svg",
                                width: "20",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  2
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "actions",
        fn: function fn() {
          return [
            _c(
              "a",
              {
                attrs: {
                  href: _vm.urlCompose,
                  "data-dialog": "width=600;height=300",
                },
              },
              [
                _c("studip-icon", {
                  staticClass: "text-bottom",
                  attrs: {
                    shape: "add",
                  },
                }),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }